import baseUrl from "../config/baseUrl";

const deleteClient = async ({ token, id }) => {
  try {
    const response = await fetch(
      `${baseUrl}/api/delete-client-table-data?contact_id=${id}`,
      {
        method: "DELETE",
        headers: {
          Accept: "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const data = await response.json();
    return data;
  } catch (error) {
    return error;
  }
};

export default deleteClient;
